import { CompanyName } from './interface';

/**
 * Icons that iOS reads only from `<link>` tags in the document head; the web
 * app manifest is ignored for them.
 */
export interface AppleIcons {
  /** Path to the PNG used for the home-screen icon. */
  appleTouchIcon: string;
  /** Real pixel dimensions of that PNG, e.g. `180x180`. */
  appleTouchIconSizes: string;
}

/** Tenants that ship another company's icon set instead of their own. */
const FAVICON_DIR_ALIASES: Partial<Record<CompanyName, CompanyName>> = {
  [CompanyName.DubaiExpressCom]: CompanyName.DubaiExpress,
};

/** Public folder holding the company's favicon set, e.g. `favicon-cerise`. */
export const getFaviconDir = (name: CompanyName): string =>
  `favicon-${FAVICON_DIR_ALIASES[name] ?? name}`;

export const APPLE_ICONS: Partial<Record<CompanyName, AppleIcons>> = {
  [CompanyName.Cerise]: {
    appleTouchIcon: '/favicon-cerise/apple-touch-icon.png',
    appleTouchIconSizes: '180x180',
  },
  [CompanyName.CityDrinks]: {
    appleTouchIcon: '/favicon-citydrinks/apple-touch-icon.png',
    appleTouchIconSizes: '180x180',
  },
  [CompanyName.DubaiExpress]: {
    appleTouchIcon: '/favicon-dubaiexpress/apple-touch-icon.png',
    appleTouchIconSizes: '180x180',
  },
  [CompanyName.DubaiExpressCom]: {
    appleTouchIcon: '/favicon-dubaiexpress/apple-touch-icon.png',
    appleTouchIconSizes: '180x180',
  },
  [CompanyName.Electronium]: {
    appleTouchIcon: '/favicon-electronium/apple-touch-icon.png',
    appleTouchIconSizes: '180x180',
  },
  [CompanyName.Heimkaup]: {
    appleTouchIcon: '/favicon-heimkaup/apple-touch-icon.png',
    appleTouchIconSizes: '180x180',
  },
  [CompanyName.Localee]: {
    appleTouchIcon: '/favicon-localee/apple-touch-icon.png',
    appleTouchIconSizes: '180x180',
  },
  [CompanyName.MCosmetic]: {
    appleTouchIcon: '/favicon-mcosmetic/apple-touch-icon.png',
    appleTouchIconSizes: '1024x1024',
  },
  [CompanyName.Storrd]: {
    appleTouchIcon: '/favicon-storrd/apple-touch-icon.png',
    appleTouchIconSizes: '1024x1024',
  },
};
